
export class Campaign {
  id: string;
  payment_type : string | null;
  overall_campaign_goals: string | null;
  constructor(data?: Partial<Campaign>) {
      this.id = data?.id ?? "";
      this.payment_type = data?.payment_type ?? null;
      this.overall_campaign_goals = data?.overall_campaign_goals ?? null;
  }
}
